import FEHeaderProps from './props';
import style from './style.module.css';
import { Confirmation, Menu } from './components';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import StartAppConfirmation from './components/startAppConfirmation';
import FEMobileBar from 'ui-kit/components/FEMobileBar';
import { SavedAddressesPicker } from 'pages/cartography/layouts/savedAddressesPicker';
import { useLocation } from 'react-router';

const FEMobileHeader = ({
  orderType,
  address,
  restaurant,
  bonusAccount,
  onAddressBarClick,
  onCloseConfirmation,
  onDeclineConfirmation,
  isOpenConfirmation,
  isOpenStartAppConfirmation,
  isOpenAddressPicker,
  onCloseAddressPicker,
  onAddAddress,
  onAddressPickerEmpty,
}: FEHeaderProps) => {
  const { t } = useTranslation();
  const location = useLocation();


  return (
    <>
      <div className={clsx(style.dataSidePadding, style.dataSide, location.pathname === '/profile' || location.pathname === "/dostavka-i-oplata" && style.dataSideDisplayNone)}>
        <div className={style.addressContainer}>
          <FEMobileBar
            onClick={onAddressBarClick}
            label={
              orderType === 'COURIER'
                ? t('cartography.header.deliveryLabel')
                : t('cartography.header.pickupLabel')
            }
            value={orderType === 'COURIER' ? address : restaurant}
            placeholder={t('cartography.header.placeholder')}
            theme='outline'
            color={'black'}
            isOpenStartAppConfirmation={isOpenStartAppConfirmation}
          />

          <Menu bonusAccount={bonusAccount} />

          <Confirmation
            value={orderType === 'COURIER' ? address : restaurant}
            open={isOpenConfirmation}
            onClose={onCloseConfirmation}
            onDeclineConfirmation={onDeclineConfirmation}
          />
          <SavedAddressesPicker
            open={isOpenAddressPicker}
            onClose={onCloseAddressPicker}
            onAddAddress={onAddAddress}
            onEmpty={onAddressPickerEmpty}
          />


        </div>
      </div>
      <StartAppConfirmation
        value={orderType === 'COURIER' ? address : restaurant}
        open={isOpenStartAppConfirmation}
        onClose={onCloseConfirmation}
        onDeclineConfirmation={onDeclineConfirmation}
      />
    </>
  );
};

export default FEMobileHeader;
export type { FEHeaderProps };
